import { render, staticRenderFns } from "./GoldCard.vue?vue&type=template&id=ee09843a&scoped=true"
import script from "./GoldCard.vue?vue&type=script&lang=ts"
export * from "./GoldCard.vue?vue&type=script&lang=ts"
import style0 from "./GoldCard.vue?vue&type=style&index=0&id=ee09843a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee09843a",
  null
  
)

export default component.exports